import PropTypes from 'prop-types';

const EnvelopeIcon = ({ className = '' }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M80 72V8C80 3.58172 76.4183 4.27116e-08 72 9.53991e-08L8 8.58591e-07C3.58172 9.11279e-07 0 3.58172 0 8V72C0 76.4183 3.58173 80 8 80L72 80C76.4183 80 80 76.4183 80 72Z"
      fill="#FFCCEF"
    />
    <mask
      id="mask0_8130_1205"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <path
        d="M80 72V8C80 3.58172 76.4183 4.27116e-08 72 9.53991e-08L8 8.58591e-07C3.58172 9.11279e-07 0 3.58172 0 8V72C0 76.4183 3.58173 80 8 80L72 80C76.4183 80 80 76.4183 80 72Z"
        fill="#0A0777"
      />
    </mask>
    <g mask="url(#mask0_8130_1205)">
      <path
        d="M80.0474 80.0009L80.0474 42.2842L-0.0476685 42.2842L-0.0476685 80.0009L80.0474 80.0009Z"
        fill="#FB6E44"
      />
      <path
        d="M39.9998 -0.0957026L-0.0476685 42.2826L80.0474 42.2826L39.9998 -0.0957026Z"
        fill="white"
      />
    </g>
  </svg>
);

EnvelopeIcon.propTypes = {
  className: PropTypes.string
};

export default EnvelopeIcon;
